"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../../index");
const aws_sdk_1 = require("aws-sdk");
class LambdaClient {
    constructor(config, options) {
        this.config = config;
        this.options = options;
    }
    // -----------------------------------------------
    //    Public methods
    // -----------------------------------------------
    async request(service, method, data = {}) {
        if (!this.lambda) {
            this.lambda = new aws_sdk_1.Lambda({ region: this.config.region });
        }
        const payload = {
            Handler: method,
            Body: data || {}
        };
        return await this.invoke(service, payload);
    }
    async invoke(name, data) {
        if (!this.lambda) {
            this.lambda = new aws_sdk_1.Lambda({ region: this.config.region });
        }
        const response = await this.lambda.invoke({
            FunctionName: name,
            Payload: JSON.stringify(data)
        }).promise();
        if (response.StatusCode && response.StatusCode >= 200 && response.StatusCode < 300) {
            const data = response.Payload ?
                JSON.parse(response.Payload.toString()) :
                undefined;
            if (data && data.errorMessage) {
                throw new index_1.ApiError(data.errorMessage);
            }
            return data;
        }
        throw new Error('Unknown error.');
    }
}
exports.LambdaClient = LambdaClient;
